import React, { useEffect, useState } from 'react'
import Text from '../../../atoms/Text'
import classNames from 'classnames'
import { PiPencilSimpleLine as EditIcon } from 'react-icons/pi'

import Question from '../Questions/Question'

const Answer = (props) => {
  const { answer, onUpdate } = props
  const [editing, setEditing] = useState(false)
  const [isScaled, setScaled] = useState(false)

  useEffect(() => {
    requestAnimationFrame(() => setScaled(true))
  }, [])

  return (
    <div
      className={classNames(
        'ease-in transition-all duration-500',
        isScaled && !editing ? 'scale-90' : 'scale-100',
      )}
    >
      <div className="flex flex-col w-full max-w-xl bg-white rounded-xl shadow p-4">
        <Text tag="p" variant="title" size="medium">
          {answer?.question.replace(/\//g, ' / ')}
        </Text>
        {editing ? (
          <div className="pt-2">
            <Question
              question={answer}
              answers={answer?.answer}
              onSubmitAnswer={(question_id, answer) => {
                setEditing(false)
                onUpdate(question_id, answer)
              }}
              showQuestions={false}
            />
          </div>
        ) : (
          <div className="text-sm text-gray-600 flex gap-3 pt-1">
            <Text
              tag="p"
              variant="label"
              size="large"
              bold={'true'}
              className="capitalize"
            >
              {Array.isArray(answer?.answer)
                ? answer.answer.join(' | ')
                : answer?.answer?.value || answer?.answer?.score}
            </Text>
            <button
              onClick={() => setEditing(true)}
              className="text-background-brand-teal font-bold hover:underline text-sm flex items-center gap-1"
            >
              Edit
              <EditIcon size={18} />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Answer
